module.exports = __webpack_public_path__ + "static/img/59.363bfd5.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/img_right_icon/59.png
// module id = bJrO
// module chunks = 1